import React from 'react';

import './style.sass';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

type ParamsType = {
    images: string[];
    title: string;
};

type ScreenshotsCasePropsType = {
    params: ParamsType;
    className?: string;
};

const ScreenshotsCase = ({ params, className }: ScreenshotsCasePropsType) => {
    return (
        <FullWrapper className={className}>
            <div className="screenshots-block">
                <div className="screenshots-block__title">{params.title}</div>
                <div className="screenshots-block__images">
                    {params.images.map((image, index) => {
                        return (
                            <img
                                className="screenshots-block__image"
                                src={image}
                                key={image}
                                alt={`скриншот ${index}`}
                            />
                        );
                    })}
                </div>
            </div>
        </FullWrapper>
    );
};

export default ScreenshotsCase;
